export default "__VITE_ASSET__DyHbtnAZ__"